import React from 'react';
import { Link } from 'react-router-dom';
import '../catalogue/styles.css';
import {
  Container,
  Breadcrumb,
  Button,
  Divider,
  Col,
  Stack,
  Schema,
  Panel,
  FlexboxGrid,
  Form,
  ButtonGroup,
} from 'rsuite';


function TextField(props) {
  const { name, label, accepter, ...rest } = props;
  return (
    <Form.Group controlId={`${name}-3`}>
      <Form.ControlLabel>{label} </Form.ControlLabel>
      <Form.Control name={name} accepter={accepter} {...rest} />
    </Form.Group>
  );
}
const { StringType } = Schema.Types;
const model = Schema.Model({
  name: StringType().isRequired('This field is required.'),
  email: StringType()
    .isEmail('Please enter a valid email address.')
    .isRequired('This field is required.')
});

const Catalogue = () => {

  return (
    <>
      <Container className='main-back main'>
        <Panel >
          <h3 className="title">Create Catalogue</h3>
          <Breadcrumb>
            <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Create Catalogue</Breadcrumb.Item>

          </Breadcrumb>
        </Panel>
        <Divider className='divide' />
        
        <FlexboxGrid justify="space-around">
        
          <FlexboxGrid.Item as={Col} colspan={24} md={10}>
          <h3 className='title'> Create a New Catalogue</h3>
            <Form model={model} fluid className='form' >
              <TextField name="name" label="* Buyer Company" Placeholder='Buyer' />
              <TextField name="name" label="* Name of the Catalogue" Placeholder='Catalogue Name' />
              <TextField name="name" label="* Buyer Email ID" Placeholder='Buyer Email' />
              <Form.Group>
              </Form.Group>
            </Form>
          </FlexboxGrid.Item>
        </FlexboxGrid>
        <Stack justifyContent="flex-end">
          <Panel>
            <ButtonGroup>
              <Link to='/selection'><Button appearance="primary" type="submit" color='cyan'>
                Next
              </Button>
              </Link>
            </ButtonGroup>
          </Panel>
        </Stack>
        <Panel>
          &#169; Hitouch Technologies. All Right Reserved.
        </Panel>
      </Container>
    </>
  )
}

export default Catalogue
